var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 32.2529H22.75L14.9625 37.4329C14.6997 37.6081 14.3942 37.7087 14.0788 37.7239C13.7633 37.7391 13.4496 37.6684 13.1711 37.5193C12.8927 37.3702 12.6599 37.1483 12.4977 36.8773C12.3355 36.6062 12.2499 36.2963 12.25 35.9804V32.2529C7 32.2529 3.5 28.7529 3.5 23.5029V13.0029C3.5 7.75293 7 4.25293 12.25 4.25293H29.75C35 4.25293 38.5 7.75293 38.5 13.0029V23.5029C38.5 28.7529 35 32.2529 29.75 32.2529Z",
    fill: "#E2E5E8",
    stroke: "#E2E5E8",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9997 19.8799V19.5124C20.9997 18.3224 21.7347 17.6924 22.4697 17.1849C23.1872 16.6949 23.9047 16.0649 23.9047 14.9099C23.9047 13.2999 22.6097 12.0049 20.9997 12.0049C19.3897 12.0049 18.0947 13.2999 18.0947 14.9099M20.991 24.0624H21.0085",
    stroke: "#333D4A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.32c0416e55c8105d3d4cebd96a59589c.svg";
export { ForwardRef as ReactComponent };